import React from 'react'
import { Container } from '@material-ui/core'

const HomePage = props => (
  <Container style={{ marginTop: 50, textAlign: 'center' }}>
    <p style={{ fontSize: 28 }}>Welcome to Tavvy&apos;s Games! Discover your new favorite game right here. You can look through the catalog to find the game that&apos;s just right for you. Whether it&apos;s a single-player, first-person shooter or a local co-op side scroller, you can find your ideal game here. We&apos;ll tell you where you can find it and how much it is. All our content is open source and user generated, so please add your favorite game, so others can discover it. Most importantly, <br/>Have Fun!</p>
  </Container>
)

export default HomePage



// WEBPACK FOOTER //
// ./src/components/Home/Home.js